import { MedicineSimilar } from '@dreryk/egabinet-prescription-frontend-api';

import { TableDataAccessor, TableKeyExtractor } from '@dreryk/react-components';

import { MedicineSafetyIndicatorsConfigResolver } from '~libs.shared.medicine';

export const medicineSearchKeyExtractor: TableKeyExtractor<MedicineSimilar> = (bean) => {
   return bean.medicine.id;
};

export const MedicineSearchDataAccessor: TableDataAccessor<MedicineSimilar> = (props) => {
   return <MedicineSafetyIndicatorsConfigResolver medicines={props.currentPage} />;
};
